
class Area  {
  id: string;
  slug: string;
  name: string;
  childOf: string;
  term: string;
}

document.addEventListener('setupCompleted', function() {

  const _win = window as any;

  _win.grecaptchaExecute('driver_form_ready').then(token => {
    console.log("captcha token", token);
  });

  $('#btnNavBecomePartner').hide();
  $('#btnNavBecomeDriver').hide();
  $('#btnNavLogin').hide();
  $('#btnNavRegister').text($('#btnApply').text());
  $('#btnNavRegister').unbind('click');
  $('#btnNavRegister').attr('href', $('#btnApply').attr('href') || '#');

  let _areas:Area[];
  _win.areas$.subscribe((areas:Area[]) => {
    _areas = areas.filter(a => Boolean(a.childOf)).map(a => ({...a, term:a.slug.toLowerCase()}));
  })
  let _areasSelected:Area[] = [];

  $('#btnApply1').click(function(event) {
    event.preventDefault();

    $(".modal").addClass('show');
  })
  $('#btnApply2').click(function(event) {
    event.preventDefault();

    $(".modal").addClass('show');
  })

  const elmResults = $('#area_results');
  elmResults.click(e => {
    if (!e.target.id || e.target.id.substring(0,5)!=='area_') return;
    const id = e.target.id.substring(5);
    _areasSelected = _areasSelected.filter(a => a.id!==id);
    $(e.target).remove();
  });

  const elmOpts = $('#area_options');
  elmOpts.click(e => {
    e.preventDefault();
    if (!e.target.id || e.target.id.substring(0,5)!=='area_') return;
    const id = e.target.id.substring(5);
    const area = _areas.find(a => a.id===id);
    if (!area) return;
    const existing = _areasSelected.find(a => a.id===area.id);
    if (existing) return;

    elmResults.append(`<li id="area_${area.id}">${area.name}, ${area.childOf} <span></span></li>`)
    _areasSelected.push(area);
  });
  $('#area').keyup(function(e){
    const searchTerm = (e.target as HTMLInputElement).value.toLowerCase();
    elmOpts.empty();
    if (searchTerm.length > 1) {
      const matches = _areas.filter(a => a.term.indexOf(searchTerm)>=0);
      matches.forEach(a => {
        elmOpts.append(`<div><a href="#" id="area_${a.id}">${a.name}, ${a.childOf}</a></div>`);
      })
    }
  })

  $("#submitForm").click(function (event) {
    event.preventDefault();

    let hasIssues = false;

    if (!$('#name').val()) {
      $('#name').parent().addClass('error');
      hasIssues = true;
    }
    if (!$('#email').val()) {
      $('#email').parent().addClass('error');
      hasIssues = true;
    }
    if (!$('#number').val()) {
      $('#number').parent().addClass('error');
      hasIssues = true;
    }
    if(!$('input[name=citizen]:checked').val()) {
      $('#inputGroup_citizen').addClass('error');
      hasIssues = true;
    }
    if (!_areasSelected.length) {
      $('#area').parent().addClass('error');
      hasIssues = true;
    }
    if(!$('input[name=hours]:checked').val()) {
      $('#inputGroup_hours').addClass('error');
      hasIssues = true;
    }
    if (hasIssues) return;

    $("#step1").hide();
    //TODO: add loader

    _win.grecaptchaExecute('contact_form_submit').then(token => {
      if (token) axios.post('/api/submit/driver', {
        _reCaptchaToken: token,
        name: $('#name').val(),
        email: $('#email').val(),
        contactNumber: $('#number').val(),
        citizen: $('input[name=citizen]:checked').val(),
        areas: _areasSelected,
        vehicle: $('#vehicle').val(),
        contract: $('input[name=hours]:checked').val(),
        availability: $('#availability').val(),
        hasDriverLicence: $('#haveLicence').val(),
        hasAndroid: $('#haveAndroid').val(),
        hasPoliceClearance: $('#haveClearance').val(),
        hasWorkPermit: $('#havePermit').val(),
        hasAsylumDocs: $('#haveAsylum').val(),
      })
      .then(function (response) {
        //console.log(response); 
        //response.data => {success:true}
        if (response.data.success) {
          $("#step2").show();
        } else {
          $("#step1").show();
          //TODO: add error message
        }
      })
      .catch(function (error) {
        console.warn('Unable to submit driver form.');
        console.log(error);
      });
    })
  })

});
